export default {
  group: 'Group',
  role_group: 'Role/Group',
  no_create_group: 'Group not created',
  download_template: 'Download.csv template',
  select_the_role_group: 'Please select the role/group',
  del_clear_already_email_desc: 'Delete files and clear parsed emails',
  now_parse_email_desc:
    'Parsing email addresses (same emails will be automatically merged).',
  success_email_length_desc:
    'Successfully parsed {{successLength}} email addresses.',
  err_email_length_desc: '{{errLength}} addresses are incorrect.',
  hide_invalid_email: 'Hide invalid email',
  show_invalid_email: 'Show invalid email',
  file_parse_err_desc:
    'File parsing failed. Please delete it and upload it again.',
  internet_error_file_err_desc:
    'The network is disconnected and the file upload fails.',
  email_valid_parse_desc: 'Invalid Email:',
  email_duplicate_parse_desc: 'Duplicate Email:',
  del_already_user: 'Delete the existing member',
  del_err_email: 'Delete the incorrect email address',

  sure_remove_member_organization:
    'Are you sure you remove "{{member}}" to the organization:{{studioName}}({{studioID}})?',

  input_many_email:
    'Please enter the email addresses of new members (press Enter to separate multiple emails).',
  upload_tips_desc:
    'You can also upload a file to read the email. Please prepare files according to the template.',
  upload_click_desc: 'Drag your files here, or click ',
  upload: 'Upload',
  edit_member: 'Edit Member',
  edit_fail: 'edit failed.',

  roles: 'Roles',
  groups: 'Groups',
  please_select_the_role_group: 'Please select the role/group',
  please_select_the_role: 'Assign roles for new members',
  approve_application: 'Approve Application',
  select: 'Select',
  select_role: 'Select Role',
  token_has_copied: 'Secret Key has been copied',
  expire_now: 'Expire Now',
  generate_token: 'Generate Key',
  access_token: 'Secret Key',
  the_token_will_expired_desc: 'The Token will be expired at this time',
  select_game: 'Select Game',
  select_environment: 'Select Environment',
  role_and_scope: 'Role & Scope',
  add_role_and_scope: 'Add Role & Scope',
  basic: 'Basic',
  add_new_group: 'Add New Group',
  edit_group: 'Edit Group',
  view_group: 'View Group',
  group_name: 'Group Name',
  group_member: 'Group Member',
  enter_name_of_group: 'Enter the name of group',
  select_member_of_group: 'Select member',
  enter_description: 'Enter the description of group',
  enter_the_role_description: 'Enter the role description',
  access_rights: 'Access Rights',
  member: 'Member',
  role: 'Role Name',
  role_uppercase: 'Role',
  delete_role: 'Delete Role',
  delete_role_desc: 'Are you sure you want to delete the role?',
  delete_role_Name_desc:
    'Are you sure you want to delete the role 【{{roleName}}】?',
  delete_member_desc: 'Are you sure you want to remove member【{{member}}】？',
  search_group: 'Search Group',
  delete_group: 'Delete Group',
  delete_group_desc: 'Are you sure you want to delete the group?',
  permissions: 'Permissions',
  search_role: 'Search Role',
  no_roles: 'no roles',
  role_has_no_rights: 'Custom roles do not have permission.',
  role_name: 'Role Name',
  add_new_role: 'Add New Role',
  edit_role: 'Edit Role',
  view_role: 'View Role',
  enter_name_of_role: 'Enter the name of role',
  please_enter_role_name: 'Please Enter Role Name!',
  please_select_access_rights: 'Please Select Access Rights!',
  please_select_members: 'Please Select Members',
  max_limit_emails_tags_20: 'The number of users must not exceed 20',
  no_permission_title: 'No Permission',
  no_rbac_permission_action:
    'You do not have permission for this operation. Please contact the studio administrator to obtain it.',
  no_support_rbac_permission_action:
    'You do not have permission for this operation.',
  enter_group_name: 'Please enter group name!',
  select_scope: 'Please select scope!',
  scope: 'Scope',
  view_show_role: 'Role',
  cannot_delete_group_desc_tips:
    'You cannot delete this group currently. Please reassign members first and then continue this operation.',
  cannot_delete_role_desc_tips:
    'You cannot delete this role currently. Please reassign members first and then continue this operation.',
  related_group: 'Related Group',
  cannot_delete_custom_role_desc_tips:
    'You cannot delete this role currently. Please unbind the associated group first and then continue this operation.',
  all_game: 'All Game',
  all_env: 'All Env',
  view_all: 'All',
  permission_all: 'All',
  permission_none: 'None',
  permission_part: 'Part',
  no_page_permission_line_one: 'Sorry, you do not have access to this page.',
  no_page_permission_line_two:
    'Please reach out to the studio admin to obtain the necessary permissions.',
  support_no_page_permission_line_one:
    'You are not authenticated to view this page.',
  support_no_page_permission_line_two:
    'Please reach out to the the super admin or admin to obtain the necessary permissions.',
  access_right_select_all: 'Select All',
  access_right_clean_all: 'Clean All',
  access_right_select_game_tips: 'Please select the game first',
  access_right_delete_tips: 'Limit to at least one Role & Scope',
  access_right_system: 'System',
  access_right_system_group: 'System',
  access_right_custom: 'Custom',
  refuse: 'Refuse',
  role_owner_desc:
    'Have the highest authority on the platform, that is, have access rights and the highest operation rights for all titles. By default, it is the title creator. This role identity can be transferred (unique in the studio).',
  role_admin_desc:
    'Have regular operation authority of the studio and have access rights and the highest operation rights for all titles.',
  role_editor_desc: 'Have editing permissions for all services.',
  role_viewer_desc:
    'Only has browsing permissions and does not have any operation permissions.',
  no_groups: 'no groups',
  per_studio: 'Studio',
  per_service: 'Services',
  per_organization: 'Organization',
  per_game: 'Title',
  per_env: 'Environment',
  per_expense: 'Expense',
  per_audit: 'AuditHub',
  per_api: 'Client API Control',
  per_audit_empty: 'No operational audit-supported services are enabled',
  gourps_modified_tips: 'System definition, cannot be modified.',
  groups_admin_desc:
    'The administrator user group has the highest authority for all game environments and affiliated services by default. The user group defined by the platform system only supports adding members.',
  groups_editor_desc:
    'The editor user group has the editing rights of all game environments and affiliated services by default. The user group defined by the platform system only supports adding members.',
  groups_viewer_desc:
    'The viewer user group has the viewing permission of all game environments and affiliated services by default. The user group defined by the platform system only supports adding members.',
  select_the_group: 'Please select the group',
  highest_selected: 'The highest privilege user group has been selected.',
  role_not_exist:
    'The role [{{roleName}}] has been deleted, please select new roles',
  task_report: 'Task Report',
  operation_report: 'Operation Report',
};
